export default {
  path: '/v5',
  name: 'V5_dashboard',
  component: () => import('./DashboardPage.vue'),
};
